export default __webpack_public_path__ + "static/media/unmute.95969fbf.svg";